import { combine } from 'effector'
import { $isPendingSuggestion } from 'src/features/suggestions/model'
import { $isPendingGroup, $isPendingSearch } from 'src/features/goods-groups-update/model'

export const $isLoadingGoods = combine(
    {
        isPendingSuggestion: $isPendingSuggestion,
        isSearchGoodsLoading: $isPendingSearch,
        isGroupGoodsLoading: $isPendingGroup
    },
    (ars) => ars.isSearchGoodsLoading || ars.isPendingSuggestion || ars.isGroupGoodsLoading
)
